import React from 'react';

interface Props {
  fillColor: string;
}

const StoolHard = ({ fillColor }: Props) => {
  return (
    <svg width='28' height='22' viewBox='0 0 28 22' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.71 6.42664C17.1778 5.19868 17.8925 3.8657 19.715 3.69476C24.084 3.28497 27.6035 8.74875 27.9676 12.027C28.2677 14.7286 26.4421 16.2047 24.084 16.8119C19.2878 18.047 10.9937 12.9566 13.8895 8.47966C14.5825 7.40845 14.7652 7.2171 15.71 6.42664Z'
        fill={fillColor}
      />
      <path
        d='M7.21523 0.826288C5.21196 0.067228 0.441995 1.84274 0.054843 3.69478C-0.430571 6.01687 2.38814 8.79271 5.27284 8.61215C7.47878 8.47408 9.70218 7.40224 9.88462 4.9241C10.0592 2.55321 8.18607 1.19415 7.21523 0.826288Z'
        fill={fillColor}
      />
      <path
        d='M0.0542341 17.4908C0.0612422 14.8188 0.44433 13.3991 2.48144 12.027C4.68696 10.5415 7.64186 11.4335 9.88462 12.8466C12.8452 14.712 15.5507 17.6539 13.04 20.2227C11.705 21.5886 0.0431279 21.7252 0.0542341 17.4908Z'
        fill={fillColor}
      />
    </svg>
  );
};

export default StoolHard;
